import React, { useState, useEffect } from 'react';
import './CreatePage.css';
import PreviewPage from './PreviewPage';
import LoadingView from '../components/LoadingView'; // 引入新组件

function CreatePage({ previewTrigger }) {
  const [activeTab, setActiveTab] = useState('recording');
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [selectedGenre, setSelectedGenre] = useState('流行');
  
  // 页面状态控制
  const [showPreview, setShowPreview] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false); 
  
  // 灵感页面状态
  const [showInspiration, setShowInspiration] = useState(false);
  const [inspirationText, setInspirationText] = useState('');
  const [isPureMusic, setIsPureMusic] = useState(false);

  const [timerInterval, setTimerInterval] = useState(null);

  // 监听来自首页的跳转指令
  useEffect(() => {
    if (previewTrigger && previewTrigger > 0) {
      setIsGenerating(false); 
      setShowInspiration(false);
      setShowPreview(true);
    }
  }, [previewTrigger]);

  // 清理定时器
  useEffect(() => {
    return () => {
      if (timerInterval) clearInterval(timerInterval);
    };
  }, [timerInterval]);

  const genres = ['古典', '电子', '流行', '乡村', '摇滚', '纯音'];
  
  const sceneCards = [
    { id: 1, tag: '热情桑巴', icon: 'fa-fire', color: '#FF6B6B' },
    { id: 2, tag: '赛博朋克', icon: 'fa-robot', color: '#4ECDC4' },
    { id: 3, tag: '校园时光', icon: 'fa-graduation-cap', color: '#95E1D3' },
    { id: 4, tag: '华夏国潮', icon: 'fa-dragon', color: '#F38181' },
    { id: 5, tag: '婉约放克', icon: 'fa-music', color: '#AA96DA' },
    { id: 6, tag: '都市韵律', icon: 'fa-city', color: '#FCBAD3' },
  ];

  // 开始生成流程
  const handleStartGeneration = () => {
    setShowInspiration(false); 
    setIsGenerating(true);
  };

  // 生成完成回调
  const handleGenerationFinish = () => {
    setIsGenerating(false);
    setShowPreview(true);
  };

  const handleRecordClick = () => {
    if (!isRecording) {
      setIsRecording(true);
      setRecordingTime(0);
      const interval = setInterval(() => {
        setRecordingTime(prev => prev + 0.1);
      }, 100);
      setTimerInterval(interval);
    } else {
      setIsRecording(false);
      if (timerInterval) {
        clearInterval(timerInterval);
      }
      handleStartGeneration(); 
    }
  };

  const handleSceneCardClick = () => {
    setInspirationText(''); 
    setIsPureMusic(false);
    setShowInspiration(true);
  };

  // 1. 如果是预览页
  if (showPreview) {
    return <PreviewPage onBack={() => setShowPreview(false)} />;
  }

  // 2. 如果是生成中页面 (使用新组件)
  if (isGenerating) {
    return (
      <LoadingView 
        title="AI 正在编曲中..." 
        subtitle="正在解析旋律与风格" 
        onFinish={handleGenerationFinish}
      />
    );
  }

  // 3. 默认创作页结构
  return (
    <div className="create-page">
      {!showInspiration && (
        <div className="create-tabs">
          <div 
            className={`create-tab ${activeTab === 'recording' ? 'active' : ''}`}
            onClick={() => setActiveTab('recording')}
          >
            录音生成
          </div>
          <div 
            className={`create-tab ${activeTab === 'scene' ? 'active' : ''}`}
            onClick={() => setActiveTab('scene')}
          >
            场景生成
          </div>
        </div>
      )}

      <div className="create-content">
        {showInspiration ? (
          <div className="inspiration-view">
            <div className="inspiration-header">
              <h3>你的灵感？</h3>
              <p>告诉 AI 你想要什么样的音乐</p>
            </div>
            <textarea
              className="inspiration-input"
              placeholder="指定语言、输入完整歌词; 或者写几个饱含你灵感的词句！"
              value={inspirationText}
              onChange={(e) => setInspirationText(e.target.value)}
            ></textarea>

            <div className="control-row">
               <div className="toggle-switch-container">
                 <span className="toggle-label">纯音乐</span>
                 <label className="switch">
                    <input 
                      type="checkbox" 
                      checked={isPureMusic}
                      onChange={(e) => setIsPureMusic(e.target.checked)}
                    />
                    <span className="slider"></span>
                 </label>
               </div>
            </div>

            <div className="action-buttons-grid">
               <button 
                  className={`inspire-btn ${inspirationText.trim() ? 'btn-primary' : 'btn-disabled'}`}
                  disabled={!inspirationText.trim()}
                  onClick={handleStartGeneration}
               >
                 <i className="fas fa-lightbulb"></i> 实现灵感
               </button>

               <button 
                  className={`inspire-btn ${!inspirationText.trim() ? 'btn-secondary' : 'btn-disabled'}`}
                  disabled={!!inspirationText.trim()}
                  onClick={handleStartGeneration}
               >
                 <i className="fas fa-dice"></i> 试试手气
               </button>
            </div>
            
            <div 
              style={{ textAlign: 'center', marginTop: '15px', color: '#999', fontSize: '14px', cursor: 'pointer' }}
              onClick={() => setShowInspiration(false)}
            >
              返回场景选择
            </div>
          </div>
        ) : (
          <>
            {activeTab === 'recording' ? (
              <div className="recording-container">
                <div className="genre-selector">
                  {genres.map(genre => (
                    <div
                      key={genre}
                      className={`genre-item ${selectedGenre === genre ? 'selected' : ''}`}
                      onClick={() => setSelectedGenre(genre)}
                    >
                      {genre}
                    </div>
                  ))}
                </div>

                <div 
                  className={`record-button ${isRecording ? 'recording' : ''}`}
                  onClick={handleRecordClick}
                >
                  <i className={`fas ${isRecording ? 'fa-stop' : 'fa-microphone'}`}></i>
                </div>

                {isRecording && (
                  <div className="recording-status">
                    <div className="recording-timer">
                      {Math.floor(recordingTime / 60)}:{(Math.floor(recordingTime % 60)).toString().padStart(2, '0')}
                    </div>
                    <div className="waveform-container">
                      <div className="waveform">
                        {[...Array(30)].map((_, i) => (
                          <div 
                            key={i} 
                            className="wave-bar" 
                            style={{ 
                              height: `${20 + Math.random() * 60}%`,
                              animationDelay: `${i * 0.1}s`
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="scene-container h-scrollable">
                <div className="scene-grid">
                  {sceneCards.map(card => (
                    <div 
                      key={card.id} 
                      className="scene-card"
                      onClick={handleSceneCardClick}
                      style={{ 
                        height: `${180 + (card.id % 3) * 40}px`,
                        backgroundColor: card.color 
                      }}
                    >
                      <i className={`fas ${card.icon} scene-icon`}></i>
                      <div className="scene-tag">{card.tag}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CreatePage;